import React from 'react';
import styled from 'styled-components';
import Title from '../../card-apply/components/title/Title';
import CommonSection from '../../card-apply/components/commonSection/CommonSection';
import { materialIcon } from '../styled/utils';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SFaq = styled.div(
  () => `
  display: flex;
  flex-direction: column;
`
);

const SFaqItem = styled.div<{ isOpen: boolean }>(
  ({ theme, isOpen }) => `
  padding: ${theme.spacing.larger}px ${theme.spacing.large}px ${theme.spacing.larger - theme.spacing.medium}px ${theme.spacing.medium}px;
  border-top: 2px solid ${theme.colors.border};
  &:last-child {
    border-bottom: 2px solid ${theme.colors.border};
  }
  /* max-height: ${isOpen ? '1000px' : '0px'}; */
  /* transition: height 0.4s ease-out; */
`
);

const SFaqItemTitle = styled.h2<{ isOpen: boolean }>(
  ({ theme, isOpen }) => `
  color: ${isOpen ? theme.colors.primary : theme.colors.grayBlueish};
  font-size: ${theme.font.size.medium};
  font-weight: ${theme.font.weight.bold};
  margin-bottom: ${theme.spacing.medium}px;
  padding-right: ${theme.spacing.larger}px;
  position: relative;
  cursor: pointer;
  &:after {
    position: absolute;
    right: 0;
    top: 0;
    /* transform: translate(0, -50%); */
    ${materialIcon(isOpen ? 'remove' : 'add', 30, theme.colors.grayBlueish)}
  }
`
);

const SFaqItemText = styled.div<{ isOpen: boolean }>(
  ({ theme, isOpen }) => `
  color: ${theme.colors.primary};
  font-size: ${theme.font.size.medium};
  margin-bottom: ${theme.spacing.medium}px;
  overflow: hidden;
  display: ${isOpen ? 'block' : 'none'};
`
);

const SFaqItemTextLink = styled.a(
  ({ theme }) => `
  text-decoration: underline;
  cursor: pointer;
  color: ${theme.colors.primaryLightBlue};
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IFaqItemProps {
  title: string;
  index: number;
  isOpen: boolean;
}
interface IFaqProps {
  faqTitle: string;
  faqData: Array<{ title: string; open?: boolean; text: string }>;
  open?: boolean;
}

interface IFaqDataItemProps {
  text: string;
}

// tslint:disable-next-line:variable-name
const FaqItem: React.FC<IFaqItemProps> = (props) => {
  const [isOpen, setIsOpen] = React.useState(props.isOpen);

  const handleOnClick = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <SFaqItem data-at="faqItem" isOpen={isOpen}>
      <SFaqItemTitle data-at="faqItemTitle" onClick={handleOnClick} isOpen={isOpen}>
        {props.title}
      </SFaqItemTitle>
      <SFaqItemText data-at="faqItemText" isOpen={isOpen}>
        {props.children}
      </SFaqItemText>
    </SFaqItem>
  );
};

// tslint:disable-next-line:variable-name
const RenderFaqDataItem: React.FC<IFaqDataItemProps> = (props) => {
  let { text } = props;
  const hyperlinkRegex = /\[(?<text>[\w\s\d./?=#;&]+)\]\((?<url>[\w\d./?=#:]+)\)|(?<linebreak>\n) /m;
  const hyperLinks = [];
  let keyIndex = 10000;
  for (let result = hyperlinkRegex.exec(text); result !== null; result = hyperlinkRegex.exec(text)) {
    if (result.groups) {
      if (result.groups.linebreak) {
        hyperLinks.push(<br key={keyIndex++} />);
      } else {
        const searchRegExp = /#&reg;/g;
        const replaceWith = '®';
        result.groups.text = result.groups.text.replace(searchRegExp, replaceWith);
        hyperLinks.push(
          <SFaqItemTextLink key={keyIndex++} href={result.groups.url || ''}>
            {result.groups.text || ''}
          </SFaqItemTextLink>
        );
      }
    }
    text = text.replace(result[0], '@@@');
  }
  const parts: Array<string | React.ElementType> = text.split('@@@');
  const renderParts = [];
  for (let i = 0, j = 0; i < parts.length; i++, j += 2) {
    renderParts[j] = (
      <span className="match" key={i}>
        {parts[i]}
      </span>
    );
    renderParts[j + 1] = hyperLinks.shift();
  }
  return <div>{renderParts}</div>;
};

// tslint:disable-next-line:variable-name
const Faq: React.FC<IFaqProps> = (props) => {
  const faqItems = props.faqData.map((faqDataItem, index) => (
    <FaqItem key={index} index={index} title={faqDataItem.title} isOpen={faqDataItem.open || false}>
      <RenderFaqDataItem text={faqDataItem.text} />
    </FaqItem>
  ));
  return (
    <SFaq>
      <CommonSection>
        <Title data-at="faqTitle">{props.faqTitle}</Title>
      </CommonSection>
      <CommonSection data-at="faqItems">{faqItems}</CommonSection>
    </SFaq>
  );
};

export default Faq;
